import { ChangeEvent } from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H5, LI, P, UL } from "../../../../AbstractElements";
import { AccountType, Continue } from "../../../../Constant";
import { SELECT_AMOUNT_DATA } from "../../../../Data/FormLayout";
import { useAppDispatch, useAppSelector } from "../../../../Redux-Toolkit/Hooks";
import ShowError from "../../common/ShowError";
import { BusinessFormCommonProps } from "../../../../Type/FormLayoutType";
import { setAccountType } from "../../../../Redux-Toolkit/Reducers/FormLayout/FormWizardTwoSlice";

const SelectAccount = ({ callbackActive }: BusinessFormCommonProps) => {
  const { accountType } = useAppSelector((state) => state.formWizardTwo);
  const dispatch = useAppDispatch();

  const getUserData = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    dispatch(setAccountType(value));
  };

  const handleNextButton = () => {
    if (accountType !== "") callbackActive(2);
    else ShowError();
  };

  return (
    <Form className="row g-3 needs-validation" noValidate onSubmit={(event) => event.preventDefault()}>
     <Row>
     <Col xs="12">
        <H5>{AccountType}</H5>
        <P>It has long been known that distracting information on a page will lose a readers attention.</P>
      </Col>
      <Col xs="12" className="mt-2">
        <FormGroup check className="radio radio-primary ps-0 select-account">
          <UL className="radio-wrapper simple-list">
            {SELECT_AMOUNT_DATA.map((data, index) => (
              <LI key={index}>
                <Input id={data.tittle} value={data.tittle} checked={data.tittle === accountType} type="radio" name="accountType" onChange={getUserData} />
                <Label className="form-check-label mb-0" htmlFor={data.tittle} check>
                  <i className={`fa ${data.iconName}`} />
                  <span className="d-flex flex-column">
                    <span>{data.tittle}</span>
                    <span>Search your {data.tittle} information please check it</span>
                  </span>
                </Label>
              </LI>
            ))}
          </UL>
        </FormGroup>
      </Col>
      <Col xs="12" className="text-end mt-3">
        <Btn onClick={handleNextButton} color="primary">{Continue}</Btn>
      </Col>
      </Row>
    </Form>
  );
};

export default SelectAccount;
